<template>
    <div class="w-full lg:w-1/2 md:w-full shadow-lg rounded-lg overflow-hidden">
        <div class="py-3 px-5 bg-gray-50">Orders Trends

            <Line
                id="pieChat"
                :options="chartOptions"
                :data="chartData"

            />
        </div>
    </div>
</template>
<script>
import {Line} from 'vue-chartjs'
import {
    Chart as ChartJS,
    CategoryScale,
    LinearScale,
    PointElement,
    LineElement,
    Title,
    Tooltip,
    Legend
} from 'chart.js'

ChartJS.register(
    CategoryScale,
    LinearScale,
    PointElement,
    LineElement,
    Title,
    Tooltip,
    Legend
)

export default {
    name: 'LineChart',
    components: {Line},
    props: {
        monthlyOrders: Array
    },
    data() {

        let labels = Object.keys(this.monthlyOrders);
        let values = Object.values(this.monthlyOrders);
        return {
            chartData: {
                labels: labels,
                datasets: [
                    {
                        label: 'Orders Trend',
                        backgroundColor: '#f87979',
                        data: values
                    }
                ]
            },
            chartOptions: {
                responsive: true
            }
        }
    },
}
</script>
